import { Pipe, PipeTransform, inject } from '@angular/core';

import { SwitchTranslateTypes, SwitchTranslationService } from '../services/switch-translation.service';

@Pipe({
  name: 'switchTranslation',
  standalone: false,
})
export class SwitchTranslationPipe implements PipeTransform {
  private readonly switchTranslationService = inject(SwitchTranslationService);

  transform(key: string, type: SwitchTranslateTypes = SwitchTranslateTypes.getText) {
    return this.switchTranslationService.get(key, type);
  }
}
